export default "__VITE_ASSET__R63iTEuP__"